import React, { Component } from "react";
import Api from "../../Services/Api";
import Images from "../../Assets/Images";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/SuperAdmin/FetchTenant";
import { toastr } from "react-redux-toastr";
import {  Link,NavLink } from "react-router-dom";
import '../../Styles/SuperAdminTenantFetch.scss'
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
class SuperAdminFetchTenant extends Component {
  constructor () {
    super();

    this.state = {
      search: "",
      skip: 0,
      take: 10,
      columnDefs: [
        {
          headerName: "Tenant Name",
          field: "tenantName",
          headerClass: 'header-bold',
          sortable: true,
          filter: true,
        },
        {
          headerName: "Address",
          field: "tenantAddress",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Telephone",
          field: "tenantPhoneNo",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Email",
          field: "tenantEmail",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Enable / Disable",
          field: "isEnabled",
          cellRendererFramework: AgGridCheckbox,
          editable: true,
          filter: true,
        },
        {
          headerName: "Actions",
          field: "Edit",
          template: `<a><img src="${Images.EDITICON}" width="14" /></a>`,
        },
      ],
      rowData: [],
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.FetchTenantData();
  }
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take
    });
  };

  navToEditTenant=(data)=>{
    console.log(data);
    // history.push({
    //   pathname: `/superadmin/home/Add`,
    //   tenantRowData:data
    // });
  }

  render() {
    
    let { tenantData, searchKey } = this.props;
    if(tenantData&&searchKey){
      tenantData = tenantData.filter((entry) =>
      Object.values(entry).some(
        (val) =>
          typeof val === "string" &&
          val.toLocaleLowerCase().includes(searchKey.toLocaleLowerCase())
      )
    );
    }
   
    return (
      <div className="tblCont dataGrids" style={{ padding: "0px" }}>
        <div className="rw-tab-content">
          <Grid
            data={
              tenantData &&
              tenantData.slice(
                this.state.skip,
                this.state.take + this.state.skip
              )
            }
            skip={this.state.skip}
            take={this.state.take}
            total={tenantData && tenantData.length}
            pageable={true}
            onPageChange={this.pageChange}
            sortable={true}
          >
            <Column field="tenantName" title="TENANT NAME" />
            <Column field="tenantAddress" title="ADDRESS" />
            <Column field="tenantPhoneNo" title="TELEPHONE" width="150" />
            <Column field="tenantEmail" title="EMAIL" />
            <Column field="userLimit" title="User Limit" width="90" />
            <Column
              field="heatmapCount"
              title="Heatmap Matrix"
              width="90"
              cell={(props) => <td>{props?.dataItem?.heatmapCount||0} X {props?.dataItem?.heatmapCount||0}</td>}
            />
            <Column
              field="isPrimeSubsibed"
              title="Prime Enabled"
              width="90"
              cell={(props) => (
                <td>
                  <span>{props.dataItem.isPrimeSubsibed ? "Yes" : "No"}</span>
                </td>
              )}
            />
            <Column
              field="isTasksModuleEnabled"
              title="Task Enabled"
              width="90"
              cell={(props) => (
                <td>
                  <span>{props.dataItem.isTasksModuleEnabled ? "Yes" : "No"}</span>
                </td>
              )}
            />
            <Column field="userRemaining" title="Remaining User" width="90" />
            <Column
              // field=""
              title="ENABLE/DISABLE"
              cell={AgGridCheckbox}
              width="120"
            />
            <Column
              // field=""
              title="ACTION"
              width="80"
              cell={(props) => (
                <td>
                  {/* <a onClick={()=>this.navToEditTenant(props.dataItem)}></a> */}
                  <NavLink
                    to={{
                      pathname: "/superadmin/home/Add",
                      tenantRowData: props.dataItem,
                    }}
                    exact
                  >
                    <img src={Images.EDITICON} width="14" />
                  </NavLink>
                </td>
              )}
            />
          </Grid>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    tenantData: state.FetchTenant.tenantData,
    searchKey: state.FetchTenant.tenantSearchKey
  };
};

function AgGridCheckbox(params) {
  const [isChecked, setIsChecked] = React.useState(
    params.dataItem.isEnabled ? true : false
  );
  const onChanged = async () => {
    var request = {
      tenantKey: params.dataItem.tenantKey,
      userId: params.dataItem.tenantId.toString(),
      tenantEmail: params.dataItem.tenantEmail,
      IsEnabled: !isChecked,
    };
    setIsChecked(!isChecked);
    let response = await Api.enableUser(request);
    if (response.status === 200) {
      toastr.success(response.message);
    } else {
      setIsChecked(!isChecked);
      toastr.error("Failed");
    }
  };
  return (
    <td>
      <label className="switch">
        <input type="checkbox" checked={ isChecked } onChange={ onChanged } />
        <span className="slider"></span>
      </label>
    </td>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperAdminFetchTenant);
